import { getDigitsFromString } from '@/utils/getDigitsFromString'
import { Patient } from '../types/en-us'
import { PacienteAtivacaoPayload } from '../types/pt-br'

class SendPatientDataActivation {
  toPersistence(data: Patient): PacienteAtivacaoPayload {
    return {
      idPaciente: data?.id,
      nome: data?.name,
      dataNascimento: data?.birthdate,
      email: data?.email,
      telefoneCelular: data?.cellphone,
      token: data?.token,
      ...(data?.clinic?.id &&
        data?.clinic?.identifier &&
        data?.clinic?.identifier !== 'CPF' &&
        data?.identifier && {
          idClinica: data?.clinic?.id,
          tipoIdentificador: data?.clinic?.identifier,
          identificador: data?.identifier,
        }),
      ...(data?.clinic?.id &&
        data?.clinic?.identifier && {
          idClinica: data?.clinic?.id,
          tipoIdentificador: data?.clinic?.identifier,
          ...(data?.clinic?.identifier === 'CPF' && {
            identificador: getDigitsFromString(data?.cpf),
          }),
          ...(data?.clinic?.identifier === 'EMAIL' && {
            identificador: data?.identifier || data?.email,
          }),
        }),
    }
  }
}

export default new SendPatientDataActivation()
